import { TranslatePipe } from '@ngx-translate/core';
import { ImmomioIconButtonComponent } from '@immomio/ui/button';
import {
  Component,
  input,
  output,
  ChangeDetectionStrategy
} from '@angular/core';

import { LandlordUser, PropertySearcherUser } from '@ui/shared/model';

import { ImageSizePipe } from '../../../pipes/image-size.pipe';
import { AvatarComponent } from '../avatar/avatar.component';
import { LogoComponent } from '../logo/logo.component';
import { ElevationDirective } from '../../../directives/elevation/elevation.directive';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslatePipe,
    ImmomioIconButtonComponent,
    LogoComponent,
    AvatarComponent,
    ImageSizePipe,
    ElevationDirective
  ]
})
export class HeaderComponent {
  readonly user = input<LandlordUser | PropertySearcherUser>(undefined);
  readonly navigationOpen = input<boolean>(undefined);
  readonly profileSettingsOpen = input<boolean>(undefined);
  readonly navigationToggleClick = output<Event>();
  readonly profileSettingsToggleClick = output<Event>();

  public onNavigationToggleClick(event: Event) {
    this.navigationToggleClick.emit(event);
  }

  public onProfileSettingsToggleClick(event: Event) {
    this.profileSettingsToggleClick.emit(event);
  }
}
